import $ from 'jquery'

import tabs from './tabs/tabs'
import table from './table/table'

export default function(o){

  if(!o.store('tableModelId')){
    o.store('tableModelId','rollsData')
  }

  var set = function(modelId){
    o.store('tableModelId',modelId)
    tableDiv.set(modelId)
    tabsDiv.set(modelId)
  }

  var update = function(){
    var modelId = o.store('tableModelId')
    set(modelId)
  }

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      top: '34px',
      left: '400px',
      right: 0,
      bottom: 0,
    })

  var tableDiv = table(o, div)
  var tabsDiv = tabs(o, div)

  div
  .append(
    tabsDiv,
    tableDiv,
  )

  div.set = set
  div.update = update

  update()

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/search.js